import PrizeItemApi from "../../services/api/PrizeItem";
import { getPath, pushOrUpdate, removeCondition } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import * as Comparators from "../../constants/FeatureToggle/Comparators";
import _ from "lodash-es";

function handleError(err) {
  console.log("error in prize-items actions:", err);
}

export const setPrizeItemList = (payload) => {
  return {
    type: ActionTypes.SET_PRIZE_ITEM_LIST,
    payload,
  };
};

export const setActivePrizeItem = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_PRIZE_ITEM,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_PRIZE_ITEM,
    payload,
  };
};

export const setCurrentPagePrizeItem = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_PRIZE_ITEM,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_PRIZE_ITEM,
    payload,
  };
};

export const getPrizeItemList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let prizeItemPayload = {
        filters: _.cloneDeep(filters),
        pageRequest: pageRequest,
      };
      _.unset(prizeItemPayload, ["filters", "serviceId"]);
      dispatch(setLoader(true));
      let response = await PrizeItemApi.getPrizeItemList(prizeItemPayload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setPrizeItemList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPagePrizeItem(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
export const getPrizeItem = (id) => async (dispatch) => {
  try {
    let prizeItemPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    const response = await PrizeItemApi.getPrizeItem(prizeItemPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActivePrizeItem(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updatePrizeItem = (data) => async (dispatch) => {
  try {
    let prizeItemPayload = { ...data };
    dispatch(setLoader(true));
    let response = await PrizeItemApi.updatePrizeItem(prizeItemPayload);
    dispatch(setLoader(false));
    if (response) {
      // dispatch(resetState({state : "activeFeature"}));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
